module.exports = __webpack_public_path__ + "img/2156.b2929023.gif";